module.exports = __webpack_public_path__ + "img/settings_3000.521d6b85.png";